import { PartNoList, PutShopUse } from '../apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../apiUtils';

export interface ShopUseParam {
  companyKey: string;
}

const endPoint = 'shop-use-company';

export const getShopUse = async (params: ShopUseParam): Promise<PartNoList> => {
  const queryParams = new URLSearchParams();
  queryParams.append('companyKey', params.companyKey);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const updateShopUse = async (newShopUse: PutShopUse): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(newShopUse),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
